import React, { useReducer, useState, useEffect } from 'react';
import style from './EditCarriagePalette.module.css';
import axios from '../../functions/axios';
import { throttle } from '../../functions/functions';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import moment from 'moment';
import DropdownList from 'react-widgets/DropdownList';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    routeStart: '',
    routeEnd: '',
    invoice: '',
    paletteExchanged: 0,
    paletteLoad: 0,
    paletteLeft: 0,
    paletteTaken: 0,
    paletteExchangedDD: 0,
    paletteLoadDD: 0,
    paletteLeftDD: 0,
    paletteTakenDD: 0,
    paletteBalDD: 0,
    paletteBalE: 0,
    receipe: false,
    clientId: location.state.client._id,
  });

  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const { user } = useAuthContext();

  useEffect(() => {
    if (!user) return null;
    let requestStopped = false;
    if (!requestStopped) {
      Promise.all([getData('/driver', setDrivers), getData('/car', setCars)]);
    }
    return () => {
      requestStopped = true;
    };
  }, [user]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    (async () => {
      if (!user || !formData.invoice) return null;
      await throttle(1000);
      try {
        const response = await axios.get(`/carriage`, {
          params: {
            populate: ['car', 'driver'],
            limit: 10,
            invoice: formData.invoice,
          },
          cancelToken: source.token,
        });
        if (response.data.length === 1) {
          const [current] = response.data;
          handleChange({ target: { name: 'day', value: current?.day } });
          handleChange({ target: { name: 'car', value: current?.car?.plate } });
          handleChange({ target: { name: 'driver', value: current?.driver?.name } });
          handleChange({ target: { name: 'routeStart', value: current?.routeStart } });
          handleChange({ target: { name: 'routeEnd', value: current?.routeEnd } });
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('axios request canceled');
          return;
        }
        console.log(err);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [user, formData.invoice]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.post(`/paletts`, { ...formData });

    await setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/carriagePaletteList', { state: { client: location.state.client } });
  };

  const handleChange = (event) => {
    let value;
    switch (event.target.type) {
      case 'number':
        value = event.target.value;
        break;
      case 'checkbox':
        value = event.target.checked;
        break;
      default:
        value = event.target.value;
        break;
    }
    setFormData({
      name: event.target.name,
      value,
    });
  };

  return (
    <div className={style.wrapper}>

      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2>Dodawanie/Edycja Palety</h2>
          <br />
          <div className={style.row}>
            <label className={style.category} htmlFor='invoice-data'>
              Faktura
            </label>
            <input id='invoice-data' type='text' name='invoice' onChange={handleChange} value={formData.invoice ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='day'>
              Data
            </label>
            {formData.day && parseDate(formData.day).day.toLocaleDateString('pl',{weekDay:'long'})}
          </div>
        {/* </div>
        <div className={style.section}> */}
          <div className={style.row}>
            <label className={style.category} htmlFor='car-data'>
              Pojazd:
            </label>
            {formData.car}
          </div>
        {/* </div>
        <div className={style.section}> */}
          <div className={style.row}>
            <label className={style.category} htmlFor='driver-data'>
              Kierowca:
            </label>
            {formData.driver}
          </div>
        </div>
        <hr />

        <div className={style.section}>
        <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            {formData.routeStart || ''}
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            {formData.routeEnd || ''}
          </div>

          <hr />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletten1'>wymienione EUR:</label>
            <input id='paletten1' type='number' name='paletteExchanged' onChange={handleChange} value={formData.paletteExchanged ?? ''} />
            <label className={style.subcategory} htmlFor='paletten2'>wymienione DD:</label>
            <input id='paletten2' type='number' name='paletteExchangedDD' onChange={handleChange} value={formData.paletteExchangedDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletten3'>załadowane EUR:</label>
            <input id='paletten3' type='number' name='paletteLoad' onChange={handleChange} value={formData.paletteLoad ?? ''} />
            <label className={style.subcategory} htmlFor='paletten4'>załadowane DD:</label>
            <input id='paletten4' type='number' name='paletteLoadDD' onChange={handleChange} value={formData.paletteLoadDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletten5'>odebrane EUR:</label>
            <input id='paletten5' type='number' name='paletteTaken' onChange={handleChange} value={formData.paletteTaken ?? ''} />
            <label className={style.subcategory} htmlFor='paletten6'>odebrane DD:</label>
            <input id='paletten6' type='number' name='paletteTakenDD' onChange={handleChange} value={formData.paletteTakenDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletten7'>zdane EUR:</label>
            <input id='paletten7' type='number' name='paletteLeft' onChange={handleChange} value={formData.paletteLeft ?? ''} />
            <label className={style.subcategory} htmlFor='paletten8'>zdane DD:</label>
            <input id='paletten8' type='number' name='paletteLeftDD' onChange={handleChange} value={formData.paletteLeftDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletten11'>Saldo palet EURO:</label>
            <input id='paletten11' type='number' name='paletteBalE' onChange={handleChange} value={formData.paletteBalE ?? location.state.carriage?.paletts?.paletteBalE ?? 0} />
            <label className={style.subcategory} htmlFor='paletten12'>Saldo palet DD:</label>
            <input id='paletten12' type='number' name='paletteBalDD' onChange={handleChange} value={formData.paletteBalDD ?? location.state.carriage?.paletts?.paletteBalDD ?? 0} />
          </div>
        </div>
        <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='paletten9'>Saldo klienta palet EURO:</label>
          <input id='paletten9' type='number' name='paletteBallanceE' onChange={handleChange} value={formData.paletteBallanceE ?? location.state?.client.paletteBallanceE ?? 0} />
          <label className={style.subcategory} htmlFor='paletten10'>Saldo klienta palet DD:</label>
          <input id='paletten10' type='number' name='paletteBallanceDD' onChange={handleChange} value={formData.paletteBallanceDD ?? location.state?.client.paletteBallanceDD ?? 0} />
        </div>
        <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='receipe'>
            Kwit?
          </label>
          <input id='receipe' type='checkbox' name='receipe' onChange={handleChange} checked={formData?.receipe } />
        </div>
        <hr />
        <div className={style.category}>Uwagi:</div>
        <div className={style.row}>
          <textarea className={style.textData} id='comments-data' name='comments' onChange={handleChange} value={formData.comments ?? ''} />
        </div>
        <hr />
        <span className={style.buttons}>
          <button id="cancel" className='btn btn-default' onClick={navigate.bind(null, '/carriagePaletteList', { state: { date: formData.day, client: location.state.client } })}>Anuluj</button>
          <button className='btn btn-default' type='submit' onClick={handleSubmit}>Zapisz</button>
        </span>
        </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = await axios.get(path) || [];
    response.sort((...args) => {
      const [a, b] = args.map(({ name, plate, companyName }) => name || plate || companyName);
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};


export default EditCarriage;
